import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { inviteService } from '@/services/InviteService'
import { inviteKeys } from '@/hooks/queryKeys'
import type { InvitePreviewDto } from '@lib/dto/invite.dto'

/**
 * Resolve an invite token to the address it was issued for, so the accept page
 * can show the recipient which account they're about to create.
 *
 * `retry: false` matters here: the expected failure is a dead token (410), and
 * retrying a deliberate rejection just delays telling the visitor.
 */
export function useInvitePreview(
  token: string,
): UseQueryResult<InvitePreviewDto> {
  return useQuery({
    queryKey: inviteKeys.preview(token),
    queryFn: () => inviteService.preview(token),
    retry: false,
    staleTime: Infinity,
  })
}
